<template>
  <div class="member-wrapper">
    <div class='content'>
      <van-cell v-if='IsAuthentication && userType !=4' title="临床偏好" is-link to='clinic-preference' />
      <van-cell v-if='IsAuthentication && userType !=4' title="收货地址" is-link to='address-list' />
      <van-cell title="安全中心" v-if="userType !=4" is-link to='account-safety' />
      <van-cell title="推送设置" v-if="userType !=4" is-link to='message-push-setting' />
      <div class='btn-wrap'>
        <div class='btn-box'>
          <van-button type="default" round size="large" @click='loginOut'>退出登录</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { Toast } from 'vant';
import store from "@/store";
export default {
  data () {
    return {
      IsAuthentication: false,
      userType: 0
    }
  },
  methods: {
    loginOut () {
      Toast.success({
        duration: 1000,
        message: '退出成功'
      })
      setTimeout(() => {
        this.$store.dispatch('FedLogOut').then(() => {
          this.$router.push({ path: '/signIn' });
          location.reload();
        })
      }, 1000)
    }
  },
  created () {
    this.userType = Cookies.get("userType")
    var UserObj = store.getters.user;
    this.IsAuthentication = UserObj.IsAuthentication;
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px 10px;
  .btn-wrap {
    width: 90%;
    margin: 100px auto;
    .van-button--plain.van-button--info {
      border: none;
      color: #414141;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/setting-page.vue